export default import.meta.ROLLUP_FILE_URL_mRZFNe5k;